"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CrudRequest = /** @class */ (function () {
    function CrudRequest() {
        var _this = this;
        this.defaultConfig = {
            callbacks: {
                checkSuccess: function (_a) {
                    var type = (_a === void 0 ? {} : _a).type;
                    return type === 'success';
                },
                createRequest: function (url, data, options) { return _this.send(__assign({ method: "post", prefix: "create/" }, options, { url: url,
                    data: data })); },
                updateRequest: function (url, data, options) { return _this.send(__assign({ method: "post", prefix: "update/" }, options, { url: url,
                    data: data })); },
                deleteRequest: function (url, data, options) { return _this.send(__assign({ method: "post", prefix: "delete/" }, options, { url: url,
                    data: data })); },
                retrieveRequest: function (url, data, options) { return _this.send(__assign({ method: "get", prefix: "retrieve/", checkDataType: false, notify: false }, options, { url: url,
                    data: data })); }
            }
        };
    }
    CrudRequest.prototype.call = function (callbackName, args) {
        if (args === void 0) { args = []; }
        var callback = this.defaultConfig.callbacks[callbackName];
        if (callback) {
            return callback.apply(this, args);
        }
    };
    CrudRequest.prototype.config = function (callback) {
        var config = __assign({}, this.defaultConfig);
        callback.apply(this, [config]);
        this.defaultConfig = config;
        return this;
    };
    CrudRequest.prototype.send = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call('sendRequest', [options])];
            });
        });
    };
    CrudRequest.prototype.create = function (url, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("createRequest", [url, data, options])];
            });
        });
    };
    CrudRequest.prototype.retrieve = function (url, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("retrieveRequest", [url, data, options])];
            });
        });
    };
    CrudRequest.prototype.update = function (url, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("updateRequest", [url, data, options])];
            });
        });
    };
    CrudRequest.prototype.delete = function (url, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("deleteRequest", [url, data, options])];
            });
        });
    };
    CrudRequest.prototype.redirect = function (to, options) {
        this.call("redirect", [to, options]);
    };
    CrudRequest.prototype.reload = function () {
        this.call("reload");
    };
    CrudRequest.prototype.alert = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("alert", [options])];
            });
        });
    };
    CrudRequest.prototype.confirm = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("confirm", [options])];
            });
        });
    };
    CrudRequest.prototype.prompt = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("prompt", [options])];
            });
        });
    };
    CrudRequest.prototype.dialog = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("dialog", [options])];
            });
        });
    };
    CrudRequest.prototype.notify = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("notify", [options])];
            });
        });
    };
    CrudRequest.prototype.toggleLoading = function (value) {
        return this.call("loading", [value]);
    };
    CrudRequest.prototype.chooseFile = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("chooseFile", [options])];
            });
        });
    };
    return CrudRequest;
}());
exports.default = CrudRequest;
